// @flow
import { ticketDashboardActions } from "./ticketDashboardActionCreator";

const initialState = {
  tickets: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticketsCount: {
    isLoading: false,
    isLoaded: false,
    data: {}
  },
  dashboardTickets: {
    label: null,
    isLoading: false,
    isLoaded: false,
    data: null
  },
  clusterLocationMapping: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticketStatusOptions: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  bulkClose: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  bulkAssign: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  searchOptions: {
    isLoaing: false,
    isLoaded: false,
    data: null
  }
};
const TicketDashboardReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case ticketDashboardActions.GET_ALL_TICKETS: {
      return Object.assign({}, state, { tickets: action.payload });
    }
    case ticketDashboardActions.GET_TICKETS_COUNT: {
      return Object.assign({}, state, { ticketsCount: action.payload });
    }
    case ticketDashboardActions.GET_DASHBOARD_TICKETS: {
      return Object.assign({}, state, { dashboardTickets: action.payload });
    }
    case ticketDashboardActions.GET_CLUSTER_LOCATION_MAPPING: {
      return Object.assign({}, state, {
        clusterLocationMapping: action.payload
      });
    }
    case ticketDashboardActions.GET_TICKET_STATUS_OPTIONS: {
      return Object.assign({}, state, {
        ticketStatusOptions: action.payload
      });
    }
    case ticketDashboardActions.BULK_CLOSE_TICKETS: {
      return Object.assign({}, state, {
        bulkClose: action.payload
      });
    }
    case ticketDashboardActions.BULK_ASSIGN_TICKETS: {
      return Object.assign({}, state, {
        bulkAssign: action.payload
      });
    }
    case ticketDashboardActions.GET_SEARCH_OPTIONS: {
      return Object.assign({}, state, { searchOptions: action.payload });
    }
    default: {
      return state;
    }
  }
};
export default TicketDashboardReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/ticketDashboard/ticketDashboardRedux/ticketDashbaordReducer.js